import useRequest from '@/websdk/utils/request';

export default (function () {
  const { exec, isRequestSuccessed } = useRequest({
    url: '/api/system/rolesauthority',
    name: 'POST_rolesauthority',
    method: 'POST',
  });

  return [exec, isRequestSuccessed];
});
